// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_header__2dWn1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  border-bottom: 1px solid var(--table-border);
  margin-bottom: 24px;
}

.style_button_group__0YOgI {
  display: flex;
  align-items: center;
  gap: 16px;
}

.style_title__NXmy2 {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

@media (max-width: 915px) {
  .style_header__2dWn1 {
    align-items: end;
  }

  .style_button_group__0YOgI {
    align-items: end;
  }

  .style_title__NXmy2 {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .style_header__2dWn1 {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MachineProfileHeader/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 0;\n  border-bottom: 1px solid var(--table-border);\n  margin-bottom: 24px;\n}\n\n.button_group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.title {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n@media (max-width: 915px) {\n  .header {\n    align-items: end;\n  }\n\n  .button_group {\n    align-items: end;\n  }\n\n  .title {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `style_header__2dWn1`,
	"button_group": `style_button_group__0YOgI`,
	"title": `style_title__NXmy2`
};
export default ___CSS_LOADER_EXPORT___;
